/**
 * Rotas que não requerem autenticação
 * Estas rotas podem ser acessadas por usuários não logados
 */
export const allowedRoutesWithoutAuth = [
  /\/acelera-magenta\/(new|complete|\d+)$/,
  /\/brilha-magenta\/(new|complete|\d+)$/,
  /\/brilha-magenta\/nota-colaborador\/[^/]+$/,
  /\/conexao-magenta\/(new|complete|\d+)$/,
  /\/experience-feedback\/(new|complete|\d+)$/,
  /\/personnel-movement\/(new|complete|\d+)$/,
  /\/refunds\/(new|complete|\d+)$/,
  /\/comprovantes-de-vendas\/enviar$/,
  /\/entrega-de-trabalho\/enviar$/,
  /\/aproveitamento-de-estudos\/new$/,
  /\/videos-de-depoimento\/enviar$/,
  /\/admissao(?:\/continuar\/[^/]+)?$/,
  /\/concurso\/[^/]+(?:\/(?:inscricao|envio))?$/
]
